import { render, staticRenderFns } from "./OneStopServiceHome.vue?vue&type=template&id=1d5751e8&scoped=true"
import script from "./OneStopServiceHome.vue?vue&type=script&lang=js"
export * from "./OneStopServiceHome.vue?vue&type=script&lang=js"
import style0 from "./OneStopServiceHome.vue?vue&type=style&index=0&id=1d5751e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5751e8",
  null
  
)

export default component.exports